import { IServicesInfo, ServicesInfoComputedType } from "../../types/servicesInfo";

export const groupServicesInfo: (servicesInfo: IServicesInfo) => ServicesInfoComputedType = (servicesInfo) => {
    let servicesInfoComputed: ServicesInfoComputedType = {
        additionalServices: [],
        mainServices: []
    };

    servicesInfo.mainServices.forEach(service => {
        if (!servicesInfoComputed.mainServices.find(s => s.type === service.type)) {
            servicesInfoComputed.mainServices.push({
                type: service.type,
                servicesInfo: [{ ...service }]
            });
        } else {
            const index = servicesInfoComputed.mainServices.findIndex(s => s.type === service.type);
            servicesInfoComputed.mainServices[index].servicesInfo.push({ ...service });
        }
    });

    servicesInfo.additionalServices.forEach(additionalService => {
        if (!servicesInfoComputed.additionalServices.find(as => as.type === additionalService.type)) {
            servicesInfoComputed.additionalServices.push({
                type: additionalService.type,
                servicesInfo: [{ ...additionalService }]
            });
        } else {
            const index = servicesInfoComputed.additionalServices.findIndex(as => as.type === additionalService.type);
            servicesInfoComputed.additionalServices[index].servicesInfo.push({ ...additionalService });
        }
    });

    return servicesInfoComputed;
}